import * as fetcher from "../helpers/fetcher";

export async function getCurrentUser(access_token) {
  const headers = access_token
    ? {
        Authorization: `Bearer ${access_token}`,
      }
    : {};
  return fetcher.get(`/user/me`, headers);
}

export async function getUser(id, access_token) {
  return fetcher.get(`/user/${id}`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function updateUser(id, firstName, lastName, phone, access_token) {
  return fetcher.patch(
    `/user/${id}`,
    {
      Authorization: `Bearer ${access_token}`,
    },
    {
      ...(firstName ? { firstName } : {}),
      ...(lastName ? { lastName } : {}),
      ...(phone ? { phone } : {}),
    }
  );
}

export async function setDefaultUserRole(id, access_token) {
  return fetcher.post(
    `/roles/assign`,
    {
      Authorization: `Bearer ${access_token}`,
    },
    { userId: id, roleId: 3 }
  );
}

export async function getNeighbourhoods(access_token) {
  return fetcher.get(`/neighborhoods`, {
    Authorization: `Bearer ${access_token}`,
  });
}


export async function getAddresses(access_token) {
  return fetcher.get(`/user/address`, {
    Authorization: `Bearer ${access_token}`,
  });
}

export async function addAddress(address, access_token) {
  return fetcher.post(
    `/user/address`,
    {
      Authorization: `Bearer ${access_token}`,
    },
    {
      address,
    }
  );
}

export async function updateAddress(id, newAddress, access_token) {
  return fetcher.patch(
    `/user/address/${id}`,
    {
      Authorization: `Bearer ${access_token}`,
    },
    {
      address: newAddress,
    }
  );
}

export async function deleteAddress(id, access_token) {
  return fetcher.deleteReq(`/user/address/${id}`, {
    Authorization: `Bearer ${access_token}`,
  });
}
